module.exports = __webpack_public_path__ + "static/carbon-file-selection-857e87aba1720e1f83293c89a58b7d9c.png";